export const SchoolZoneStingers = [
  {
    name: 'Stinger 01',
    message: "It's is a great day at XXX, you're listening to SchoolZone!",
  },
  {
    name: 'Stinger 02',
    message: 'SchoolZone...your soundtrack for another awesome day at XXX!',
  },
  {
    name: 'Stinger 03',
    message: 'Always the best music for XXX...this is SchoolZone!',
  },
  {
    name: 'Stinger 04',
    message: 'SchoolZone...your source for the best music, here at XXX!',
  },
  {
    name: 'Stinger 05',
    message:
      'Here at XXX, have fun! Keep learning! And enjoy the great  music here on SchoolZone!',
  },
  {
    name: 'Stinger 06',
    message: 'XXX...a great place to be! And this is SchoolZone!',
  },
  {
    name: 'Stinger 07',
    message: 'At XXX, together everyone achieves more! And this is SchoolZone!',
  },
  {
    name: 'Stinger 08',
    message:
      "You're listening to SchoolZone...your home for great music at XXX!",
  },
  {
    name: 'Stinger 09',
    message: 'The best mix of the best music! This is SchoolZone, at XXX!',
  },
  {
    name: 'Stinger 10',
    message:
      'A great day deserves great music...here at XXX, this is SchoolZone!',
  },
];
export const GameTimeBaseMessage = [
  {
    name: 'GT Base Message 01',
    message:
      'That was another great song here on GAMETIME! XXX Athletics wants to remind you that good sportsmanship is one of the primary purposes of educational athletics. Our student-athletes recognize that judgment calls by officials, coaches, and themselves, are made in good faith and should be respected. Spectators can support both of these teams by refraining from derogatory or demeaning comments and cheers today. We hope that you will enjoy the game and support the students in a positive and sportsmanlike manner. More awesome tunes are coming up...here on GAMETIME!',
  },
  {
    name: 'GT Base Message 02',
    message:
      'Another great song here on GAMETIME! XXX fans, sportsmanship is a vital part of athletics. During the contest, if you see someone using poor behavior, please notify facility personnel. Sportsmanship is of utmost importance, and everyone should enjoy the contest in a fun and healthy environment. Thank you for your cooperation. More music is coming up here on GAMETIME!',
  },
  {
    name: 'GT Base Message 03',
    message:
      "We've got some great tunes to go along with all the excitement on GAMETIME here for the XXX fans! Athletic officials are seldom given the appreciation they deserve. They are given the responsibility and authority to enforce the rules of the game. Please treat the officials with the same good sportsmanship you treat the students. More music is coming up here on GAMETIME!",
  },
  {
    name: 'GT Base Message 04',
    message:
      "We hope you're having a wonderful time while we play some great music on GAMETIME! Welcome to XXX High School…All fans should realize that by their attendance at this game they become participants, and the schools are ultimately responsible for all participants. More music to come here on GAMETIME!",
  },
  {
    name: 'GT Base Message 05',
    message:
      "We hope you're having a good time listening to some great music here on GAMETIME! Remember XXX fans…Student-athletes represent their teams, fellow students, teachers, and their school community. Athletes are expected to be individuals who will make a good impression for their schools. Another game day tune is coming up here on GAMETIME!",
  },
];

export const GameTimeStingers = [
  {
    name: 'Stinger 01',
    message: ['This is Gametime, in the home of the XXX!'],
    isSelected: 0,
  },
  {
    name: 'Stinger 02',
    message: [
      'Here in XXX, we’re your source for the best music!',
      'Welcome to XXX…this is the home of the XXX!',
    ],
    isSelected: 0,
  },
  {
    name: 'Stinger 03',
    message: ["When it's game day for the XXX…the soundtrack is Gametime!"],
    isSelected: 0,
  },
  {
    name: 'Stinger 04',
    message: [
      'Your soundtrack for great times at XXX!',
      'More great music for you…in the home of the XXX!',
    ],
    isSelected: 0,
  },
  {
    name: 'Stinger 05',
    message: ["It's a powerful combination…the XXX and Gametime!"],
    isSelected: 0,
  },
  {
    name: 'Stinger 06',
    message: [
      'Always the best music, right here for the XXX!',
      'Your soundtrack for the best times! And here in XXX, we love our XXX!',
    ],
    isSelected: 0,
  },
  {
    name: 'Stinger 07',
    message: [
      "It's game day for the XXX…and that means it's Gametime!",
      'This is the home of the XXX…and you’re listening to Gametime!',
    ],
    isSelected: 0,
  },
  {
    name: 'Stinger 08',
    message: [
      'This is where the XXX rule! Welcome to XXX!',
      "We're backing the XXX…and playing great music for your game day!",
    ],
    isSelected: 0,
  },
  {
    name: 'Stinger 09',
    message: [
      'When the XXX play, Gametime is on the air!',
      'Show that XXX Pride! It’s Gametime for XXX!',
    ],
    isSelected: 0,
  },
  {
    name: 'Stinger 10',
    message: [
      'More awesome music, all the time…here at XXX!',
      'Your playlist for the best times! Welcome to XXX!',
    ],
    isSelected: 0,
  },
];

export const NeptuneStingers = [
  {
    primary: 'Agritainment',
    data: [
      {name: 'Stinger 01', message: "Welcome to XXX! You're listening to YYY!"},
      {
        name: 'Stinger 02',
        message: 'This place is big time fun! And your soundtrack is YYY!',
      },
      {
        name: 'Stinger 03',
        message:
          'XXX is the place to be! Fun for everybody, and great music from YYY!',
      },
      {
        name: 'Stinger 04',
        message: 'YYY…a great part of any adventure at XXX!',
      },
      {
        name: 'Stinger 05',
        message:
          'At XXX, you bring yourself and get ready for fun…YYY brings the tunes!',
      },
      {
        name: 'Stinger 06',
        message: 'Fantastic family fun with great music! This is YYY!',
      },
      {
        name: 'Stinger 07',
        message:
          'At XXX we bring it all…jump on board! And your soundtrack for fun? It’s YYY!',
      },
      {
        name: 'Stinger 08',
        message: 'XXX is the place to be this season…and this is YYY!',
      },
      {
        name: 'Stinger 09',
        message:
          'There’s so much to do here at XXX! Enjoy it all! And we’ll keep playing great music for you here on YYY!',
      },
      {
        name: 'Stinger 10',
        message: 'Thanks for listening to the super fun sounds of YYY!',
      },
      {
        name: 'Stinger 11',
        message: 'Fun music all day, every day! This is YYY!',
      },
      {
        name: 'Stinger 12',
        message:
          'Have fun exploring all of XXX…we’d love to come along, but we’ve got all these songs to play…on YYY!',
      },
      {
        name: 'Stinger 13',
        message: 'Great music for your day at the farm…This is YYY!',
      },
      {
        name: 'Stinger 14',
        message: 'XXX welcomes you. Thanks for listening to YYY!',
      },
      {
        name: 'Stinger 15',
        message:
          "Acres and acres of fun and tons of music to go with it - you're listening to YYY!",
      },
      {
        name: 'Stinger 16',
        message: 'YYY…Your soundtrack to fun, all day long!',
      },
      {
        name: 'Stinger 17',
        message:
          'The official radio of XXX and fun-seekers everywhere…This is YYY!',
      },
      {
        name: 'Stinger 18',
        message: 'Welcome to your favorite fun spot! XXX…and this is YYY!',
      },
      {
        name: 'Stinger 19',
        message: 'Your place for fun and entertainment! This is YYY!',
      },
      {
        name: 'Stinger 20',
        message:
          'Always the best music, all day long! You’re listening to YYY!',
      },
    ],
  },
  {
    primary: 'All Other',
    data: [
      {name: 'Stinger 01', message: 'The best music is always here…on XXX!'},
      {
        name: 'Stinger 02',
        message:
          'This is the place to be! And a great soundtrack, here on XXX!',
      },
      {
        name: 'Stinger 03',
        message: 'XXX…your source for great music, all day long!',
      },
      {
        name: 'Stinger 04',
        message: 'XXX…your soundtrack for a great day on campus!',
      },
      {
        name: 'Stinger 05',
        message: 'Always the best music, picked just for you…here on XXX!',
      },
      {
        name: 'Stinger 06',
        message:
          'Hope you’re having a great time! We’ve got more awesome tunes for you on XXX!',
      },
      {
        name: 'Stinger 07',
        message: 'XXX…Your source for fun, and fantastic music!',
      },
      {
        name: 'Stinger 08',
        message: 'Thanks for listening to the super fun sounds of XXX!',
      },
      {
        name: 'Stinger 09',
        message: 'Your soundtrack for another awesome day! This is XXX!',
      },
      {
        name: 'Stinger 10',
        message: 'Fun music for another great day here on campus! This is XXX!',
      },
      {
        name: 'Stinger 11',
        message: 'Fun music, all day…every day! Here on XXX!',
      },
      {
        name: 'Stinger 12',
        message:
          'Hope you’re having a blast! And enjoying some great tunes here on XXX!',
      },
      {
        name: 'Stinger 13',
        message: 'Thanks for listening to the great music, here on XXX!',
      },
      {
        name: 'Stinger 14',
        message: 'This place is big time fun! And XXX supplies the music!',
      },
      {
        name: 'Stinger 15',
        message: 'XXX…your soundtrack for fun, all day long!',
      },
      {
        name: 'Stinger 16',
        message: 'XXX! Your official station for on-campus fun!',
      },
      {
        name: 'Stinger 17',
        message: 'Your official playlist for the best music…XXX!',
      },
      {
        name: 'Stinger 18',
        message: 'Your playlist for great times…this is XXX!',
      },
      {
        name: 'Stinger 19',
        message: 'You’re listening to XXX! The best music anywhere!',
      },
      {
        name: 'Stinger 20',
        message: 'It’s another good day…with a great soundtrack here on XXX!',
      },
    ],
  },
  {
    primary: 'Attractions & Entertainment',
    data: [
      {
        name: 'Stinger 01',
        message:
          "Welcome to the XXX! It’s big-time family fun! You're listening to YYY!",
      },
      {
        name: 'Stinger 02',
        message: 'At the XXX you bring YOU… and YYY brings the tunes!',
      },
      {
        name: 'Stinger 03',
        message:
          'This place is fun for the whole family! And your soundtrack is YYY!',
      },
      {
        name: 'Stinger 04',
        message:
          'Hope you’re having a great time here at The XXX! We’ve got more awesome tunes for you on YYY!',
      },
      {
        name: 'Stinger 05',
        message:
          'The XXX is the place to be! Fun for everybody, and great music from YYY!',
      },
      {
        name: 'Stinger 06',
        message: 'Thanks for listening to the super fun sounds of YYY!',
      },
      {
        name: 'Stinger 07',
        message: 'Fun music for another great day at the XXX! This is YYY!',
      },
      {
        name: 'Stinger 08',
        message:
          'The XXX welcomes you…have a blast today! And thanks for listening to YYY!',
      },
      {name: 'Stinger 09', message: 'Thank you for tuning into…YYY!'},
      {
        name: 'Stinger 10',
        message:
          'The official radio of The XXX and fun-seekers everywhere…This is YYY!',
      },
      {
        name: 'Stinger 11',
        message:
          'Welcome to your favorite family fun spot! We’re famous for fun! And this is YYY!',
      },
      {
        name: 'Stinger 12',
        message:
          'Your place for family fun and entertainment! And your soundtrack is YYY, where we’re famous for fun!',
      },
      {
        name: 'Stinger 13',
        message: 'You’re listening to YYY! Welcome to The XXX!',
      },
      {
        name: 'Stinger 14',
        message: 'YYY -- a great part of your adventure here at The XXX!',
      },
      {
        name: 'Stinger 15',
        message: 'This place is big time fun! And YYY supplies the music!',
      },
      {
        name: 'Stinger 16',
        message:
          'Hope your’re having a blast! And enjoying some great tunes! This is YYY, where we’re famous for fun!',
      },
      {
        name: 'Stinger 17',
        message:
          'When you’re at The XXX, excitement is everywhere! And it’s YYY on the air!',
      },
      {
        name: 'Stinger 18',
        message: 'YYY…Your soundtrack to fun for everyone here at The XXX!',
      },
      {
        name: 'Stinger 19',
        message: 'Welcome to your favorite spot for fun! And this is YYY!',
      },
      {
        name: 'Stinger 20',
        message: 'This is YYY…have a great day here at The XXX!',
      },
    ],
  },
  {
    primary: 'Campgrounds',
    data: [
      {
        name: 'Stinger 01',
        message: 'It’s another great day here at XXX! You’re listening to YYY!',
      },
      {
        name: 'Stinger 02',
        message:
          'Fun for the whole family! And a great soundtrack here on YYY!',
      },
      {
        name: 'Stinger 03',
        message: 'Always the best music, right here on YYY!',
      },
      {
        name: 'Stinger 04',
        message:
          'Here at XXX we’re all about fun! And great music, here on YYY!',
      },
      {
        name: 'Stinger 05',
        message: 'Big fun at XXX! And awesome tunes here on YYY!',
      },
      {name: 'Stinger 06', message: 'Fun music, Fun times…at XXX! – YYY!'},
      {name: 'Stinger 07', message: 'YYY! Your soundtrack to fun at XXX!'},
      {
        name: 'Stinger 08',
        message: 'Turn it up! You’re listening to YYY at XXX!',
      },
      {name: 'Stinger 09', message: 'YYY, the best music here at XXX!'},
      {
        name: 'Stinger 10',
        message: 'Thanks for listening to the super fun sounds of YYY!',
      },
      {name: 'Stinger 11', message: 'YYY…your soundtrack to fun at the XXX.'},
      {
        name: 'Stinger 12',
        message: 'It’s your source for fresh music at XXX… YYY!',
      },
      {
        name: 'Stinger 13',
        message:
          'Welcome to another great time at XXX. Thanks for listening to YYY!',
      },
      {
        name: 'Stinger 14',
        message: 'We make a stay at XXX even more fun -- YYY!',
      },
      {
        name: 'Stinger 15',
        message: 'YYY! The official radio of XXX! We’ve got fun for everyone!',
      },
      {
        name: 'Stinger 16',
        message: 'Glad you’ve joined the fun at XXX…This is YYY!',
      },
      {
        name: 'Stinger 17',
        message: 'Great times, and great friends! This is YYY!',
      },
      {
        name: 'Stinger 18',
        message: 'XXX is your source for family fun… enjoy YYY.',
      },
      {
        name: 'Stinger 19',
        message: 'You’re listening to YYY! Great times begin at XXX.',
      },
      {name: 'Stinger 20', message: 'YYY at XXX…Tune in, have fun!'},
    ],
  },
  {
    primary: 'Fitness Centers',
    data: [
      {
        name: 'Stinger 01',
        message: 'You’re listening to YYY! Your workout soundtrack for XXX!',
      },
      {
        name: 'Stinger 02',
        message:
          'Put the work in with YYY! We’ll keep the music going for you!',
      },
      {
        name: 'Stinger 03',
        message: 'Always the best music for your work outs! This is YYY!',
      },
      {
        name: 'Stinger 04',
        message: "Stretch! Lift! Stretch! Let’s go! You're listening to YYY!",
      },
      {
        name: 'Stinger 05',
        message: 'YYY…A great part of any workout here at XXX!',
      },
      {
        name: 'Stinger 06',
        message: 'At XXX you bring you! And YYY brings the tunes!',
      },
      {name: 'Stinger 07', message: 'More reps means more tunes…here on YYY!'},
      {
        name: 'Stinger 08',
        message: "Stronger, faster, sleeker! You're listening to YYY!",
      },
      {
        name: 'Stinger 09',
        message:
          'At XXX you don’t need a spotter for great music, just ears. This is YYY!',
      },
      {
        name: 'Stinger 10',
        message:
          'Let’s go, one more set…You’ve got this! You’re listening to YYY!',
      },
      {
        name: 'Stinger 11',
        message: 'Tune in, tone up, and get moving! You’re listening to YYY!',
      },
      {
        name: 'Stinger 12',
        message: 'Thanks for listening to the super fit sounds of YYY!',
      },
      {
        name: 'Stinger 13',
        message:
          'Here at XXX, we never let up! The work outs continue with YYY!',
      },
      {
        name: 'Stinger 14',
        message: 'Let’s go! Get your work out on to the great music on YYY!',
      },
      {
        name: 'Stinger 15',
        message: 'It’s your workout soundtrack at XXX…keep it here on YYY!',
      },
      {
        name: 'Stinger 16',
        message:
          'Let’s keep working, and get it done! Your workout soundtrack is YYY!',
      },
      {
        name: 'Stinger 17',
        message:
          'We’d love to work out with you but we’ve got all these songs to play -- YYY!',
      },
      {
        name: 'Stinger 18',
        message:
          'Keep your workout going! It’s a good kind of burn! This is YYY!',
      },
      {
        name: 'Stinger 19',
        message: 'XXX welcomes you. Thanks for listening to YYY!',
      },
      {
        name: 'Stinger 20',
        message:
          "The tunes get better while you get more fit - you're listening to YYY!",
      },
      {name: 'Stinger 21', message: 'YYY…Your soundtrack to a more fit YOU!'},
      {
        name: 'Stinger 22',
        message:
          'The official radio of XXX Campus Recreation and champions everywhere. This is YYY!',
      },
      {
        name: 'Stinger 23',
        message:
          "The perfect combo of fitness and fun - you're listening to YYY",
      },
      {name: 'Stinger 24', message: 'Body by you and XXX… Cool tunes by YYY!'},
      {name: 'Stinger 25', message: 'We lead…and never let up! XXX at YYY!'},
      {
        name: 'Stinger 26',
        message: 'It’s your home for great music! YYY at XXX!',
      },
      {
        name: 'Stinger 27',
        message:
          "The music gets better while your muscles get stronger - you're listening to YYY!",
      },
      {
        name: 'Stinger 28',
        message: 'YYY …It’s your soundtrack to fitness fun at XXX!',
      },
    ],
  },
  {
    primary: 'Neptune U',
    data: [
      {
        name: 'Stinger 01',
        message: 'You’re listening to YYY! Your soundtrack for XXX!',
      },
      {
        name: 'Stinger 02',
        message: 'Always the best music for XXX! This is YYY!',
      },
      {
        name: 'Stinger 03',
        message: 'XXX welcomes you. Thanks for listening to YYY!',
      },
      {name: 'Stinger 04', message: 'The official radio of XXX…This is YYY!'},
      {
        name: 'Stinger 05',
        message: 'It’s your home for great music! YYY at XXX!',
      },
      {
        name: 'Stinger 06',
        message: "Great music for XXX! You're listening to YYY!",
      },
      {name: 'Stinger 07', message: 'You’re locked into big fun! This is YYY!'},
      {name: 'Stinger 08', message: 'Here at XXX …this is YYY!'},
      {
        name: 'Stinger 09',
        message:
          'The perfect mix of music for good times…you’re listening to YYY!',
      },
      {
        name: 'Stinger 10',
        message:
          'Thanks for listening to YYY! Here at XXX, we’re your playlist for fun!',
      },
      {
        name: 'Stinger 11',
        message: 'Just great music…all the time! Enjoy! It’s YYY!',
      },
      {name: 'Stinger 12', message: 'Here at the XXX…your playlist is YYY!'},
      {
        name: 'Stinger 13',
        message: 'Your XXX soundtrack! This is YYY for XXX!',
      },
      {name: 'Stinger 14', message: 'YYY…a big part of your day here at XXX!'},
      {
        name: 'Stinger 15',
        message: 'You’re listening to the awesome sounds of YYY!',
      },
      {name: 'Stinger 16', message: 'This is YYY! Welcome to XXX!'},
      {
        name: 'Stinger 17',
        message: 'YYY…bringing the music for another great day at XXX!',
      },
      {
        name: 'Stinger 18',
        message: 'The perfect mix of music! Here at XXX, this is YYY!',
      },
      {name: 'Stinger 19', message: 'Here at XXX, you’re listening to YYY!'},
      {
        name: 'Stinger 20',
        message: 'YYY…a great part of your time here at XXX!',
      },
    ],
  },
  {
    primary: 'Recreation',
    data: [
      {
        name: 'Stinger 01',
        message: 'It’s another great day here at XXX! You’re listening to YYY!',
      },
      {
        name: 'Stinger 02',
        message:
          'Fun for the whole family! And a great soundtrack here on YYY!',
      },
      {
        name: 'Stinger 03',
        message: 'Always the best music, right here on YYY!',
      },
      {
        name: 'Stinger 04',
        message:
          'Here at XXX we’re all about fun! And great music, here on YYY!',
      },
      {
        name: 'Stinger 05',
        message: 'Big fun in the outdoors! And awesome tunes here on YYY!',
      },
      {name: 'Stinger 06', message: 'Fun music, Fun times…at XXX! – YYY!'},
      {name: 'Stinger 07', message: 'YYY! Your soundtrack to fun at XXX!'},
      {
        name: 'Stinger 08',
        message: 'You’re listening to YYY at the XXX…Get movin’!',
      },
      {
        name: 'Stinger 09',
        message: 'Thanks for hangin’ at the XXX…This is YYY!',
      },
      {
        name: 'Stinger 10',
        message: 'Turn it up! You’re listening to YYY at the XXX!',
      },
      {name: 'Stinger 11', message: 'YYY, at the XXX for fun!'},
      {
        name: 'Stinger 12',
        message: 'Thanks for listening to the super fun sounds of YYY!',
      },
      {name: 'Stinger 13', message: 'YYY…your soundtrack to fun at the XXX.'},
      {
        name: 'Stinger 14',
        message: 'It’s your source for fresh music at XXX… YYY!',
      },
      {
        name: 'Stinger 15',
        message:
          'Welcome to another great time at XXX. Thanks for listening to YYY!',
      },
      {
        name: 'Stinger 16',
        message: 'We make playing at XXX even more fun -- YYY!',
      },
      {
        name: 'Stinger 17',
        message: 'YYY! The official radio of XXX! We’ve got fitness and fun!!',
      },
      {
        name: 'Stinger 18',
        message: 'Have some fun at XXX! You’re listening to YYY!',
      },
      {
        name: 'Stinger 19',
        message: 'Glad you’ve joined the fun at XXX…This is YYY!',
      },
      {name: 'Stinger 20', message: 'YYY…the sound of awesomeness!'},
      {
        name: 'Stinger 21',
        message: 'YYY mixes the music, and XXX mixes the fun!',
      },
      {
        name: 'Stinger 22',
        message: 'Great times, and great friends! This is YYY!',
      },
      {name: 'Stinger 23', message: 'XXX is your source for fun… enjoy YYY.'},
      {
        name: 'Stinger 24',
        message: 'You’re listening to YYY! Great times begin at XXX.',
      },
      {name: 'Stinger 25', message: 'YYY at XXX…Tune in, have fun!'},
    ],
  },
  {
    primary: 'Trampoline',
    data: [
      {
        name: 'Stinger 01',
        message: "Welcome to XXX! – you're listening to YYY!",
      },
      {
        name: 'Stinger 02',
        message: 'YYY -- a great part of your adventures here at XXX!',
      },
      {
        name: 'Stinger 03',
        message: 'At XXX you bring YOU… and YYY brings the tunes!',
      },
      {
        name: 'Stinger 04',
        message:
          'This place is big time family fun! And your soundtrack is YYY!',
      },
      {
        name: 'Stinger 05',
        message: 'Catch some air! And some great tunes! This is YYY!',
      },
      {
        name: 'Stinger 06',
        message:
          'Hope you’re having a great time here at XXX! We’ve got more great tunes for you on YYY!',
      },
      {
        name: 'Stinger 07',
        message:
          'When you’re at XXX, fun is in the air! And ON the air? It’s YYY!',
      },
      {
        name: 'Stinger 08',
        message:
          'XXX is the place to be! Fun for the whole family, and great music from YYY!',
      },
      {
        name: 'Stinger 09',
        message:
          'The official radio of XXX and thrill-seekers everywhere…This is YYY!',
      },
      {
        name: 'Stinger 10',
        message: 'Welcome to your favorite family fun spot! And this is YYY!',
      },
      {
        name: 'Stinger 11',
        message:
          'Your place for family fun and entertainment! And your soundtrack is YYY!',
      },
      {
        name: 'Stinger 12',
        message:
          'It’s your home for big air…and great times! And fantastic music too, with YYY!',
      },
      {name: 'Stinger 13', message: 'This is YYY…have a bouncing great day!'},
      {
        name: 'Stinger 14',
        message: 'When it’s time for big fun and big air, it’s time for YYY!',
      },
      {
        name: 'Stinger 15',
        message: 'You catch the air. We’ll catch the tunes...This is YYY.',
      },
      {
        name: 'Stinger 16',
        message: 'Take a big bounce with some big tunes…You’re jamming to YYY!',
      },
      {
        name: 'Stinger 17',
        message: 'Bouncing your way to new heights with YYY!',
      },
      {
        name: 'Stinger 18',
        message:
          'Bigger bounces, bigger air, better tunes…You’re listing to YYY.',
      },
      {
        name: 'Stinger 19',
        message: 'Take flight with great fun at XXX…you’re flying to YYY!',
      },
      {
        name: 'Stinger 20',
        message: 'It’s your soundtrack to catching big air, YYY!',
      },
    ],
  },
  {
    primary: 'Waterparks/Pools',
    data: [
      {
        name: 'Stinger 01',
        message:
          'Family fun, cool waves, and great times! You’re listening to YYY!',
      },
      {name: 'Stinger 02', message: 'This is YYY! Keep on splashing!'},
      {
        name: 'Stinger 03',
        message: 'Here at XXX your playlist for good times is YYY!',
      },
      {
        name: 'Stinger 04',
        message: 'Great times and family fun are the mix…here on YYY!',
      },
      {
        name: 'Stinger 05',
        message: 'The best music, always…right here on YYY!',
      },
      {
        name: 'Stinger 06',
        message: 'Welcome to XXX! Your soundtrack for fun is YYY!',
      },
      {
        name: 'Stinger 07',
        message:
          'Catch a wave or just chill out! We’ll keep the music coming here on YYY!',
      },
      {
        name: 'Stinger 08',
        message: 'At XXX, it’s fun out when the sun’s out! And this is YYY!',
      },
      {
        name: 'Stinger 09',
        message:
          'Fun in the sun for the whole family! And awesome tunes here on YYY!',
      },
      {
        name: 'Stinger 11',
        message: 'YYY…your home for the best music, always!',
      },
      {
        name: 'Stinger 12',
        message: 'Splash on at XXX…You are listening to YYY!',
      },
      {
        name: 'Stinger 13',
        message: 'Soak up the sun and soak up the fun with YYY!',
      },
      {
        name: 'Stinger 14',
        message: 'Your summertime, family fun favorites are here on…YYY!',
      },
      {
        name: 'Stinger 15',
        message: 'You’re listening to YYY...It’s splashtastic!',
      },
      {
        name: 'Stinger 16',
        message: 'It’s time to get soaked at XXX…you’re listening to YYY!',
      },
      {
        name: 'Stinger 17',
        message: 'We’re the perfect mix of cool summer fun…we’re YYY!',
      },
      {
        name: 'Stinger 18',
        message: 'No shirt, no shoes, no problem at XXX…this is YYY!',
      },
      {name: 'Stinger 19', message: 'YYY...It’s a blast!'},
      {
        name: 'Stinger 20',
        message: 'Every day’s a soakin’ fun day at XXX… this is YYY!',
      },
      {
        name: 'Stinger 21',
        message:
          'It’s your favorite place for family fun, XXX! And this is YYY!',
      },
      {
        name: 'Stinger 22',
        message: 'The heat is on at XXX…and you’re chillin’ to YYY!',
      },
      {
        name: 'Stinger 23',
        message:
          'No running on the deck! But slide, splash or dance all you want with YYY.',
      },
      {name: 'Stinger 24', message: 'Slide into fun…and great music…on YYY!'},
      {
        name: 'Stinger 25',
        message: 'You’re locked-in to cool summer fun…you’re locked-in to YYY!',
      },
      {
        name: 'Stinger 26',
        message:
          'No sand, no jellyfish, no sharks, just fun at XXX…you’re listening to YYY!',
      },
      {name: 'Stinger 27', message: 'XXX is the hot spot…YYY makes it cool!'},
      {
        name: 'Stinger 28',
        message: 'Chilin’ on a hot day here at XXX with YYY!',
      },
      {
        name: 'Stinger 29',
        message: 'XXX is rockin’ to…YYY, so it’s gonna be a great day!',
      },
      {name: 'Stinger 30', message: 'Catch a surf of great music…on YYY!'},
      {name: 'Stinger 31', message: 'We make summer COOL…on YYY!'},
      {
        name: 'Stinger 32',
        message: 'Here at XXX…the best music is always on YYY!',
      },
      {
        name: 'Stinger 33',
        message: 'Have a splashing good time here at XXX! This is YYY!',
      },
      {
        name: 'Stinger 34',
        message:
          'Welcome to XXX…your home for fun! And great music, here on YYY!',
      },
      {
        name: 'Stinger 35',
        message:
          'We’ve got the sun, cool water, and great times…and the best music, here on YYY!',
      },
      {
        name: 'Stinger 36',
        message: 'YYY…your source for fun…and awesome music!',
      },
    ],
  },
];
